import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { BreakdownPoint } from "@/core/analytics/analytics-utils";

interface RotationBarChartProps {
  data: BreakdownPoint[];
  emptyLabel?: string;
}

export function RotationBarChart({
  data,
  emptyLabel = "Aucune orientation enregistrée sur la période.",
}: RotationBarChartProps) {
  if (data.length === 0) {
    return <div className="ph-chart-empty text-muted">{emptyLabel}</div>;
  }

  const chartData = data.map((d) => ({
    name: d.name.length > 18 ? `${d.name.slice(0, 16)}…` : d.name,
    fullName: d.name,
    count: d.value,
  }));

  return (
    <div className="ph-chart-wrap">
      <ResponsiveContainer width="100%" height={Math.max(260, chartData.length * 36)}>
        <BarChart
          data={chartData}
          layout="vertical"
          margin={{ top: 8, right: 16, left: 8, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" horizontal={false} />
          <XAxis type="number" allowDecimals={false} tick={{ fontSize: 11, fill: "#64748b" }} />
          <YAxis
            type="category"
            dataKey="name"
            width={120}
            tick={{ fontSize: 11, fill: "#64748b" }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            content={({ active, payload }) => {
              if (!active || !payload?.[0]) return null;
              const p = payload[0].payload as { fullName: string; count: number };
              return (
                <div
                  style={{
                    padding: "8px 12px",
                    borderRadius: 8,
                    border: "1px solid #e2e8f0",
                    background: "#fff",
                    fontSize: 13,
                  }}
                >
                  <div className="fw-semibold">{p.fullName}</div>
                  <div>{p.count} orientation(s)</div>
                </div>
              );
            }}
          />
          <Bar dataKey="count" fill="#7c3aed" radius={[0, 6, 6, 0]} maxBarSize={22} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
